"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImmutableAlgorithmBlockGroup = void 0;
const immutableAlgorithmBlockGroups = ['palmLine_emotion_image', 'palmLine_emotion_question'];
const isImmutableAlgorithmBlockGroup = (blockGroup) => {
    var _a;
    return (((_a = blockGroup.logic) === null || _a === void 0 ? void 0 : _a.type) !== undefined) && immutableAlgorithmBlockGroups.includes(blockGroup.logic.type);
};
exports.isImmutableAlgorithmBlockGroup = isImmutableAlgorithmBlockGroup;
